import React from 'react';
import { useNavigate } from 'react-router-dom';

const BottomNavigation = ({ 
  currentView, 
  currentSection,
  onHomeClick, 
  onSectionClick, 
  onCalendarClick, 
  onSocialMediaClick 
}) => {
  const navigate = useNavigate();

  const navItems = [
    {
      id: 'home',
      icon: '🏠',
      label: 'Inicio',
      isActive: currentView === 'main',
      onClick: onHomeClick
    },
    {
      id: 'buenos-dias',
      icon: '🌅',
      label: 'Buenos días',
      isActive: currentView === 'list' && currentSection === 'Buenos días',
      onClick: () => onSectionClick('Buenos días')
    },
    {
      id: 'calendario',
      icon: '📅',
      label: 'Agenda',
      isActive: currentView === 'calendar' || currentView === 'fullcalendar',
      onClick: onCalendarClick
    },
    {
      id: 'media',
      icon: '❤️',
      label: 'A tu lado',
      isActive: currentView === 'social',
      onClick: onSocialMediaClick
    },
    {
      id: 'configuracion',
      icon: '⚙️',
      label: 'Ajustes',
      isActive: false, // La página de configuración tiene su propio layout
      onClick: () => navigate('/configuracion')
    }
  ];

  return (
    <div 
      className="fixed left-1/2 transform -translate-x-1/2 glass-effect rounded-3xl"
      style={{
        bottom: 'max(calc(env(safe-area-inset-bottom, 0px) - 14px), 6px)',
        width: 'min(400px, calc(100vw - 24px))',
        background: 'rgba(255,255,255,0.92)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        padding: '10px 10px',
        zIndex: 1000,
        boxShadow: '0 4px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.04)'
      }}
    >
      <div className="flex justify-around items-center">
        {navItems.map((item) => (
          <button
            key={item.id}
            onClick={item.onClick}
            className={`flex flex-col items-center gap-1 transition-all duration-300 p-2 rounded-lg ${
              item.isActive 
                ? 'transform -translate-y-1' 
                : 'hover:transform hover:-translate-y-1'
            }`}
            style={{
              color: item.isActive ? 'var(--primary-red)' : 'var(--text-secondary)'
            }}
          >
            <div className="flex items-center justify-center w-6 h-6 text-lg">
              {item.icon}
            </div>
            <span className="text-xs font-semibold">
              {item.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default BottomNavigation;